import { Api } from 'src/apis/api';

export class GatewayService {
  private static instance: GatewayService;

  static getInstance(): GatewayService {
    if (!GatewayService.instance) {
      GatewayService.instance = new GatewayService();
    }
    return GatewayService.instance;
  }

  async fetchGateways(
    merchantId: string | number,
    orderId?: string,
  ): Promise<any[]> {
    try {
      const data = await Api.getMerchants({
        billerId: `${merchantId}`,
        orderId,
      });
      return data;
    } catch (error) {
      console.error('[Gateway Service] Error fetching gateways:', error);
      return [];
    }
  }

  async getGatewayInfo(
    merchantId: string | number,
    orderId?: string,
  ): Promise<any> {
    if (!merchantId) return null;

    try {
      const gateways = await this.fetchGateways(merchantId, orderId);

      let gateway = gateways.find(
        g => String(g.billerId).trim() === String(merchantId).trim(),
      );

      if (!gateway && gateways.length > 0) {
        gateway = gateways[0];
      }

      return gateway;
    } catch (error) {
      console.error(
        `[Gateway Service] Error getting gateway for merchant ID ${merchantId}:`,
        error,
      );
      return null;
    }
  }
}
